import { useState } from "react";
import { useSpotUser } from "@/utils/spotUser";
import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";
import { CheckContext } from "./CheckFields";

export function useCheckContext(
  assistantId: string,
  enabled: boolean
): CheckContext | undefined {
  const { spotGroup } = useSpotUser();
  const { data: agentTools, isError: isToolsError } = useRemoteData(
    DATA_KEYS.ASSISTANT_TOOLS,
    { path: { group_id: spotGroup.id, assistant_id: assistantId } },
    { enabled, retry: false, staleTime: 60_000 }
  );
  const knowledgeBaseIds = agentTools?.knowledge_base_ids.join(",") ?? "";
  const { data: knowledgeBases, isError: isKnowledgeBasesError } =
    useRemoteData(
      DATA_KEYS.KNOWLEDGE_BASES_V2,
      {
        path: { group_id: spotGroup.id },
        query: { ids: knowledgeBaseIds, size: 100 },
      },
      { enabled: Boolean(knowledgeBaseIds) }
    );

  const isLoaded =
    isToolsError ||
    (agentTools !== undefined &&
      (!knowledgeBaseIds || knowledgeBases || isKnowledgeBasesError));
  const [wasLoaded, setWasLoaded] = useState(false);
  if (isLoaded && !wasLoaded) {
    setWasLoaded(true);
  }
  if (!isLoaded && !wasLoaded) {
    return undefined;
  }
  return {
    tools: agentTools?.tools ?? [],
    knowledgeBases: (knowledgeBases?.items ?? []).map((kb) => ({
      id: kb.id,
      name: kb.name,
    })),
  };
}
